import { BaseService } from "mrb/core";
import { PodcastCategoryLookupApiRouteService } from "common/services";

class PodcastCategoryLookupService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new PodcastCategoryLookupApiRouteService());
    }
}

export default PodcastCategoryLookupService;
